export type IfoStatus = 'coming_soon' | 'live' | 'finished'

export interface Ifo {
  id: string
  isActive: boolean
  address: string
  name: string
  subTitle?: string
  description?: string
  launchDate: string
  launchTime: string
  saleAmount: string
  raiseAmount: string
  cakeToBurn: string
  projectSiteUrl: string
  currency: string
  currencyAddress: string
  tokenDecimals: number
  releaseBlockNumber: number
}

export enum QuoteToken {
  'BNB' = 'BNB',
  'CAKE' = 'CAKE',
  'VLAD' = 'VLAD',
  'LIFE' = 'LIFE',
  'ALIFE' = 'ALIFE',
  'VLADALIFE' = 'VLADALIFE',
  'VLADBUSD' = 'VLADBUSD',
  'SYRUP' = 'SYRUP',
  'BUSD' = 'BUSD',
  'TWT' = 'TWT',
  'UST' = 'UST',
}

export enum PoolCategory {
  'COMMUNITY' = 'Community',
  'CORE' = 'Core',
  'BINANCE' = 'Binance', // Pools using native BNB behave differently than pools using a token
}

export interface Address {
  97?: string
  56: string
}

export interface FarmConfig {
  pid: number
  mustHaveNft: number
  lpSymbol: string
  lpAddresses: Address
  tokenSymbol: string
  tokenAddresses: Address
  quoteTokenSymbol: QuoteToken
  quoteTokenAdresses: Address
  multiplier?: string
  isTokenOnly?: boolean
  isCommunity?: boolean
  risk: number
  dual?: {
    rewardPerBlock: number
    earnLabel: string
    endBlock: number
  }
}

export interface PoolConfig {
  sousId: number
  image?: string
  tokenName: string
  stakingTokenName: QuoteToken
  stakingLimit?: number
  stakingTokenAddress?: string
  contractAddress: Address
  poolCategory: PoolCategory
  projectLink: string
  tokenPerBlock: string
  sortOrder?: number
  harvest?: boolean
  isFinished?: boolean
  tokenDecimals: number
}

export type Nft = {
  name: string
  metadata: string
  description: string
  originalImage: string
  previewImage: string
  fileType: string
  blurImage: string
  sortOrder: number
  nftId: number
  tokenAmount: number
  tokenSupply: number
  nftFarmContract: string
  nftContract: string
  rarity?: string
  tradeId?: number
}

export type SellableNft = {
  name: string
  metadata: string
  description: string
  originalImage: string
  previewImage: string
  fileType: string
  blurImage: string
  sortOrder: number
  nftId: number
  tokenAmount: number
  tokenSupply: number
  nftFarmContract: string
  nftContract: string
  rarity?: string
  tradeId?: number
  allowSell: boolean
  sellMinPrice: number
  totalArtistFee: number
  totalGovernanceFee: number
  lastSellIn: string
  lastSellPrice: number
  qtdSells: number
  totalCollected: number
  totalDevFee: number
  sellableTradeIds: Array<number>
  totalQuantity: number
  authorName: string
  authorTwitter: string
  sellPrice: string
  sellDate: string
  soldDate: string
  trade: number
}
